import { type FC } from 'react';
import {
  type UiBoxProps
} from '@/lib/ui';
import BaseAppDigitalPosterCard from '@/base/App/DigitalPosterCard';
import ModuleCard, { type ModuleCardProps } from './ModuleCard';

export interface DigitalPosterProps extends Omit<ModuleCardProps, 'children'> {
}

const DigitalPoster: FC<DigitalPosterProps> = ({
  ...props
}) => {
  return (
    <ModuleCard
      {...props}
    >
      <BaseAppDigitalPosterCard />
    </ModuleCard>
  );
};

export default DigitalPoster;
